import React, {PropTypes} from 'react';

class SelectionShow extends React.Component {

  constructor () {
    super();
    this.toggleSelection = this.toggleSelection.bind(this);
  }

  toggleSelection () {
    let selection = this.props.selection;
    let selectionActions = this.props.selectionActions;

    if(selection.displayed) {
      selectionActions.hideSelection();
    }
    else {
      selectionActions.showSelection();
      selectionActions.hideInfobox();
    }
  }

  render() {
    let selection = this.props.selection;

    // Hide the whole container if there are zero zones selected
    let container_class = "show-selection-container";
    if (selection.area_ids.length == 0) {
      container_class += " hide";
    }

    return (
      <div className={container_class}>
        <a className="btn btn-default btn-sm btn-block btn-white" onClick={this.toggleSelection} role="button">
          Your selection ({selection.area_ids.length})
        </a>
      </div>
    );
  }
}

SelectionShow.propTypes = {
  selection: PropTypes.object.isRequired,
  selectionActions: PropTypes.object.isRequired
};

export default SelectionShow;



/** WEBPACK FOOTER **
 ** ./src/components/SelectionShow.js
 **/